import fi from './fi.json';
import en from './en.json';
import sv from './sv.json';
import es from './es_ES.json';
export var DEFAULT_LANGUAGE = 'en';
var languages = {
    'fi-FI': fi,
    'fi-SV': sv,
    'en-US': en,
    'es-ES': es,
    fi: fi,
    sv: sv,
    en: en,
    es: es
};
export default languages;
